import { parse, stringify } from 'qs'

const url = (urlString, params = {}) => {
  const url = new URL(urlString)
  const combinedParams = { ...parse(url.search.slice(1)), ...params }
  url.search = stringify(combinedParams)
  return url.toString()
}

const navigateWithParams = paramsKey => {
  const urlParams = parse(window.location.search.replace('?', ''))
  const newParams = stringify({ ...urlParams, [paramsKey]: true })
  const newPath = `${window.location.pathname}?${newParams}`

  window.history.pushState({}, '', newPath)
  window.location.reload() // Optionally reload the page if necessary
}

const displayDeleteSuccessMessage = () => {
  navigateWithParams('deleted')
}

const displayUpdateSuccessMessage = () => {
  navigateWithParams('success')
}

const displayPendingMessage = () => {
  navigateWithParams('pending')
}

export default {
  url,
  displayPendingMessage,
  displayDeleteSuccessMessage,
  displayUpdateSuccessMessage
}
